'use client';

import { faHouseBlank } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import Link from 'next/link';

import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';

interface MainContentHeaderProps {
	backLinkUrl?: string;
	className?: string;
}

export const MainHeader = ({ backLinkUrl, className }: MainContentHeaderProps) => {
	const teamLeagueInfo = useTeamLeagueInfo();

	return (
		<div className={clsx('m-auto flex h-9 w-full items-center justify-between bg-white', className)}>
			<Link href={backLinkUrl ?? '#'} className="flex items-center gap-2 text-gray-900 hover:text-gray-700">
				<div className="mx-0 flex h-6 items-center gap-2 px-0">
					<FontAwesomeIcon icon={faHouseBlank} className="size-5 text-gray-900" />
					<span className="text-base font-medium leading-6 text-black">{teamLeagueInfo.title}</span>
				</div>
			</Link>
		</div>
	);
};
